module.exports = __webpack_public_path__ + "img/profile-placeholder.6a20c676.png";